<template lang="pug">
div
    el-dialog#modal-editar-territorio(
        width='700px',
        :visible.sync='mostrar',
        :before-close='fechar',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        close='fechar'
    )
        span(slot='title')

            h1.font-weight-bold
                i(class='mdi mdi-alert-circle warning')
                span(v-if='operacao.length > 0') {{ $t('mensagens.territorio.territorioJaVinculadoEmOperacoes') }}
                span(v-else) {{ $t('mensagens.territorio.edicaoTerritorioEmMonitoramento') }}

        #corpo-monitoramento(v-if='operacao.length > 0')
            #corpo
                h3 {{ $t('mensagens.territorio.territorioPossuiOperacaoAtiva') }}

                el-table.table-territorios(
                    height='100%',
                    :data='operacao',
                    style='width: 100%'
                )
                    el-table-column(
                        prop='identificador',
                        :label="$t('mensagens.operacao.tabela.id')",
                        min-width='200px'
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.identificador }}

                    el-table-column(
                        prop='dataLiberacao',
                        :label="$t('mensagens.operacao.tabela.dataCadastro')",
                        min-width='200px'
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.dataCadastro }}

                    el-table-column(
                        prop='categoria',
                        :label="$t('mensagens.operacao.tabela.tipo')",
                        min-width='100px'
                    )
                        template(slot-scope='scope')
                            span {{ (scope.row.categoria) ? scope.row.categoria : '--' }}

        #corpo-monitoramento(v-else)
            #corpo
                h3 {{ $t('mensagens.territorio.territorioNaoPossuiMonitoramentosAtivos') }}

                el-table.table-territorios(
                    height='100%',
                    :data='data',
                    style='width: 100%'
                )
                    el-table-column(
                        prop='tipoMonitoramento',
                        :label="$t('mensagens.territorio.tipoMonitoramento')",
                        min-width='200px'
                    )
                        template(slot-scope='scope')
                            span {{ $t(`mensagens.territorio.${scope.row.tipoMonitoramento.codigo.toLowerCase()}`) }}

                    el-table-column(
                        prop='dataCadastro',
                        :label="$t('mensagens.territorio.dataEnvio')",
                        min-width='200px'
                    )
                        template(slot-scope='scope')
                            span {{ mxFormatarData(scope.row.dataCadastro) }}

                    el-table-column(
                        prop='safra',
                        :label="$t('mensagens.territorio.cicloAno')",
                        min-width='100px'
                    )
                        template(slot-scope='scope')
                            span {{ (scope.row.safra) ? scope.row.safra.descricao : '--' }}

                h3 {{ $t('mensagens.territorio.vocePodeRealizarEdicaoParcial') }}

                el-radio-group.edicao(v-model='edicao', size='small')
                    el-radio(label='Simples') {{ $t('mensagens.territorio.realizarAcaoSimples') }}

                    el-radio(label='Cancelar') {{ $t('mensagens.territorio.cancelarMonitoramentosRealizarEdicao') }}

        div(slot='footer')
            .buttons
                BaseButton(size='large', @click='fechar')
                    | {{ $t('mensagens.comuns.voltar') }}
                BaseButton(
                    v-if='operacao.length === 0',
                    type='primary',
                    size='large',
                    @click='confirmarMonitoramento'
                )
                    | {{ $t('mensagens.comuns.confirmar') }}
    ModalConfirmarEdicao(
        :mostrar='showModalConfirmarEdicao',
        @fechar='sairModalConfirmarEdicao',
        @confimar='cancelarModalConfirmarEdicao'
    )

</template>
        
<script>

import DataMixin from '@/mixins/DataMixin';
import ModalConfirmarEdicao from '@/components/territorio/modalEditarTerritorio/ModalConfirmarEdicao.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarTerritorio',
    components: {
        ModalConfirmarEdicao,
        BaseButton
    },
    emits: ['fechar', 'finalizar'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        operacao: {
            type: Array,
            required: true
        }

    },

    mixins: [DataMixin],
    data() {
        return {
            edicao: null,
            showModalConfirmarEdicao: false
        };
    },

    mounted() {

    },

    watch: {

    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        confirmarMonitoramento() {
            if (this.edicao) {
                if (this.edicao === 'Simples') {
                    this.$emit('editar', this.data[0].territorio, true);
                    this.fechar();
                } else {
                    this.showModalConfirmarEdicao = true;
                }

            } else {
                this.$notify.warning({
                    message: this.$t('mensagens.territorio.selecioneTipoEdicao')
                });
            }
        },

        cancelarModalConfirmarEdicao() {
            this.showModalConfirmarEdicao = false;
            this.$emit('editar', this.data[0].territorio, false, this.data);
            this.fechar();
        },

        sairModalConfirmarEdicao() {
            this.showModalConfirmarEdicao = false;
        },

        formatarDataTableColumn(row, column, data, index) {
            return this.mxFormatarData(data);
        }
    }
};
</script>
        
<style lang="scss">
#modal-editar-territorio {
    border-radius: 5px;

    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }

    .el-dialog__body {
        padding: 30px 20px 30px;

        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }

        h3 {
            font-size: 16px;
            word-break: keep-all;
            text-align: justify;
        }
    }

    .edicao {
        margin-top: 30px;
    }

    .el-radio{
        margin-bottom: 10px !important;
    }

    .edicao .el-radio__label {
        margin-right: 10px;
 
    }

    .table-territorios {
        margin: 30px 0;
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }

}
</style>
